<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
            @clear="gameClear"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区服:">
          <el-select
            v-model="searchValue.zone_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in serverSelectList"
              :key="i"
              :label="item.name"
              :value="item.zone_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期:">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="新增类型:">
          <el-select
            v-model="searchValue.append_type"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in appendType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="去重类型:">
          <el-select
            v-model="searchValue.deduplication"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in deduplicationType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.group_channel_ids"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否分渠道">
          <el-select
            v-model="searchValue.is_channel"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in listRechannel"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchRetainStatisticsList"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportRetainCycleStatistics()"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column fixed prop="register_date" label="日期" width="120px">
      </el-table-column>
      <el-table-column fixed prop="game.game_name" label="游戏" width="180">
      </el-table-column>
      <el-table-column
        fixed
        prop="channels.channel_name"
        label="渠道名"
        width="180"
      >
      </el-table-column>
      <el-table-column
        v-if="searchValue.zone_id != ''"
        prop="zone.zone_name"
        label="区服"
        width="180"
      ></el-table-column>
      <el-table-column prop="reg_num" label="当日新增" min-width="140px">
      </el-table-column>
      <el-table-column
        v-for="(val, key, i) in keyValue"
        :key="i"
        :prop="'details.' + key"
        :label="key"
        width="100px"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
export default {
  name: "retainCycleStatistics",
  components: {},
  data() {
    return {
      loadingData: false,
      value1: [],
      searchValue: {
        zone_id: [],
        game_id: "",
        channel_id: [],
        group_channel_ids: "",
        append_type: "",
        deduplication: "",
        created_from: "",
        created_to: "",
        is_channel: "",
      },
      appendType: [
        {
          id: "reg_num ",
          name: "新增账号",
        },
        {
          id: "total_num ",
          name: "总新增角色",
        },
        {
          id: "first_num ",
          name: "首次新增角色",
        },
        {
          id: "repeat_num ",
          name: "新增滚服角色",
        },
      ],
      deduplicationType: [
        {
          id: "device_num",
          name: "设备去重",
        },
        {
          id: "ip_num",
          name: "IP去重",
        },
      ],
      listRechannel: [
        {
          id: 0,
          name: "不分渠道",
        },
        {
          id: 1,
          name: "分渠道",
        },
      ],
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamesList: [],
      channelSelectList: [],
      channelSelectAllList: [],
      channelGroupSelectList: [],
      serverSelectList: [],
      keyValue: {},
      value: [],
      collect: null,
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.addDate();
    let date = moment().startOf("month"); //当月第一天
    let y = date.get("year");
    let m = date.get("month") + 1;
    let d = date.get("date");
    let dateStart = y + "-" + m + "-" + d;

    this.value1[0] = dateStart;
    this.value1[1] = this.systemTime;

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1];

    this.getGameSelectList();
    this.getChannelSelect();
    this.channelGroupSelect();
    this.getRetainStatisticsList(true);
  },

  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRetainStatisticsList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRetainStatisticsList(false);
    },
    addDate() {
      let date1 = moment().endOf("month"); //当月最后一天
      let yy = date1.get("year");
      let mm = date1.get("month") + 1;
      let dd = date1.get("date");
      this.systemTime = yy + "-" + mm + "-" + dd;
    },
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.gamesList = res.data.data;
        }
      });
    },
    // 获取渠道选择列表数据
    getChannelSelect() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.channelSelectAllList = res.data.data;
          this.channelSelectList = res.data.data;
        }
      });
    },
    // 获取区服选择列表数据
    getServerSelectList(vid) {
      fetch({
        url: "/admin/zones/select",
        method: "GET",
        params: {
          game_id: vid,
        },
      }).then((res) => {
        if (res.data.status) {
          this.serverSelectList = res.data.data;
        }
      });
    },
    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.channelGroupSelectList = res.data.data;
        }
      });
    },
    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (item.game_id == vid) {
          this.channelSelectList.push(item);
        }
      });
      if (vid) {
        this.getServerSelectList(vid);
      }
    },
    // 清空游戏选项
    gameClear() {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.serverSelectList = [];
      this.getChannelSelect();
    },
    // 实现留存统计数据的搜索
    searchRetainStatisticsList() {
      this.searchValue.created_from = this.value1 && this.value1.length === 2 ? this.value1[0] : '';
      this.searchValue.created_to = this.value1 && this.value1.length === 2 ? this.value1[1] : '';
      this.currentPage = 1;
      this.getRetainStatisticsList(true);
    },
    // 留存统计
    getRetainStatisticsList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      let zone_id = this.searchValue.zone_id.toString();
      fetch({
        url: "/admin/cycle_statistics/daily_retain",
        method: "GET",
        params: {
          ...searchValue,
          channel_id: channel_id,
          zone_id: zone_id,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            const data = res.data.data[0]
            this.tableData = data.data;
            this.totalRecords = data.total;
            this.collect = res.data.data.collect
            let that = this;
            if (data.data.length > 0) {
              that.keyValue = data.data[0].details;
            }
            data.data.forEach((item, i) => {
              Object.keys(item.details).forEach((key) => {
                item.details[key] =
                  ((item.details[key] / item.reg_num) * 100).toFixed(
                    2
                  ) + "%";
              });
            });
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    // 导出
    exportRetainCycleStatistics() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/cycle_statistics/daily_retain", params);
    },
    // 数据统计
    getSummaries() {
      let arr = ["合计", "", ""];
      if (this.collect && this.collect['reg_num']) arr.push(this.collect['reg_num'])
      for (let key in this.keyValue) {
        arr.push(this.collect[key])
      }
      return arr;
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
